import { Locale } from "models/locale";
import { doPost } from "./request";

interface SignicatSessionsResponseInterface {
  authenticationUrl: string;
}

export const adminDoPostSignicatSessions = async (locale: Locale) => {
  const response = await doPost<SignicatSessionsResponseInterface>(
    "/admin/login/signicat",
    { locale },
  );
  return response;
};

export const userDoPostInvitationSignicatSessions = async (
  invitationUuid: string,
  locale: Locale,
) => {
  const response = await doPost<SignicatSessionsResponseInterface>(
    `/user/invitation/${invitationUuid}/login/signicat`,
    { locale },
  );
  return response;
};

export const userDoPostListSignicatSessions = async (
  listUuid: string,
  locale: Locale,
) => {
  const response = await doPost<SignicatSessionsResponseInterface>(
    `/user/list/${listUuid}/login/signicat`,
    { locale },
  );
  return response;
};
